import React, { useState, useEffect } from 'react';
import { registerDriver, getClients } from '../api/api';
import { useNavigate } from 'react-router-dom';

function DriverRegister() {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    firstname: '',
    lastname: '',
    address: '',
    phone: '',
    hire_date: new Date().toISOString().split('T')[0],
    internal_id: '',
    agency: '',
    vehicle_plate: '',
    vehicle_type: '',
    license_number: '',
    license_validity: '',
    client_ids: []
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    try {
      const response = await getClients();
      setClients(response.data);
    } catch (err) {
      console.error('Erreur chargement clients:', err);
      setError('Impossible de charger la liste des clients. Veuillez réessayer plus tard.');
    }
  };

  const handleClientToggle = (clientId) => {
    setFormData(prev => {
      const newClientIds = prev.client_ids.includes(clientId)
        ? prev.client_ids.filter(id => id !== clientId)
        : [...prev.client_ids, clientId];
      return { ...prev, client_ids: newClientIds };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (formData.client_ids.length === 0) {
      setError('Veuillez sélectionner au moins un client.');
      setLoading(false);
      return;
    }

    try {
      await registerDriver(formData);
      alert('Inscription réussie ! Vous pouvez maintenant vous connecter.');
      navigate('/login');
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de l\'inscription');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card" style={{ maxWidth: '700px' }}>
        <h1>🚛 Inscription Chauffeur</h1>
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <h3>Identité</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div className="form-group">
              <label>Prénom *</label>
              <input type="text" value={formData.firstname} onChange={(e) => setFormData({...formData, firstname: e.target.value})} required />
            </div>
            <div className="form-group">
              <label>Nom *</label>
              <input type="text" value={formData.lastname} onChange={(e) => setFormData({...formData, lastname: e.target.value})} required />
            </div>
          </div>

          <h3 style={{ marginTop: '1.5rem' }}>Coordonnées</h3>
          <div className="form-group">
            <label>Adresse</label>
            <input type="text" value={formData.address} onChange={(e) => setFormData({...formData, address: e.target.value})} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div className="form-group">
              <label>Téléphone</label>
              <input type="tel" value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Email *</label>
              <input type="email" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} required />
            </div>
          </div>
          <div className="form-group">
            <label>Mot de passe *</label>
            <input type="password" value={formData.password} onChange={(e) => setFormData({...formData, password: e.target.value})} required minLength="6" />
          </div>

          <h3 style={{ marginTop: '1.5rem' }}>Informations professionnelles</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div className="form-group">
              <label>Date de prise de poste *</label>
              <input type="date" value={formData.hire_date} onChange={(e) => setFormData({...formData, hire_date: e.target.value})} required />
            </div>
            <div className="form-group">
              <label>Matricule interne</label>
              <input type="text" value={formData.internal_id} onChange={(e) => setFormData({...formData, internal_id: e.target.value})} />
            </div>
          </div>
          <div className="form-group">
            <label>Agence de rattachement</label>
            <input type="text" value={formData.agency} onChange={(e) => setFormData({...formData, agency: e.target.value})} />
          </div>

          <h3 style={{ marginTop: '1.5rem' }}>Véhicule</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div className="form-group">
              <label>Immatriculation</label>
              <input type="text" value={formData.vehicle_plate} onChange={(e) => setFormData({...formData, vehicle_plate: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Type de véhicule</label>
              <input type="text" value={formData.vehicle_type} onChange={(e) => setFormData({...formData, vehicle_type: e.target.value})} placeholder="Ex: Fourgon, Utilitaire" />
            </div>
          </div>

          <h3 style={{ marginTop: '1.5rem' }}>Permis de conduire</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div className="form-group">
              <label>Numéro de permis</label>
              <input type="text" value={formData.license_number} onChange={(e) => setFormData({...formData, license_number: e.target.value})} />
            </div>
            <div className="form-group">
              <label>Date de validité</label>
              <input type="date" value={formData.license_validity} onChange={(e) => setFormData({...formData, license_validity: e.target.value})} />
            </div>
          </div>

          <h3 style={{ marginTop: '1.5rem' }}>Clients servis *</h3>
          <div style={{ background: '#f8f9fa', padding: '1rem', borderRadius: '8px', marginBottom: '1rem' }}>
            {clients.map(client => (
              <div key={client.id} style={{ marginBottom: '0.5rem' }}>
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={formData.client_ids.includes(client.id)}
                    onChange={() => handleClientToggle(client.id)}
                    style={{ marginRight: '0.5rem', width: 'auto' }}
                  />
                  <span>{client.name} ({client.payment_mode === 'stop' ? 'au stop' : 'au colis'})</span>
                </label>
              </div>
            ))}
          </div>

          <button type="submit" className="btn-primary" disabled={loading} style={{ width: '100%' }}>
            {loading ? 'Inscription...' : 'S\'inscrire'}
          </button>

          <div style={{ marginTop: '1rem', textAlign: 'center' }}>
            <a href="/login" style={{ color: '#B8472E' }}>Déjà inscrit ? Se connecter</a>
          </div>
        </form>
      </div>
    </div>
  );
}

export default DriverRegister;
